// 2020-06-27export { TropaTransporteListComponent } from './tropa-transporte-list.component';